<template>
        <v-list
            two-line
            subheader
            id="scroller"
            class="overflow-y-auto pb-12"
            style="border-radius: 0;"
            height="70vh"
        >
            <v-list-item-group
                v-model="selected"
                active-class="chosen-message"
            >
                <template v-for="email in emailsChain.messages">
                    <v-list-item
                        :key="email.id"
                        @click="$emit('select-email', email)"
                    >
                        <template v-slot:default="{ active, toggle }">
                            <v-list-item-avatar :color="active ? 'white' : 'primary lighten-5'">
                                <v-img
                                    v-if="email.brand && email.brand.code != 'other'"
                                    alt="sender avatar image"
                                    :src="getBrandIconPath(email.brand.name)"
                                />
                                <v-icon
                                    v-else
                                    color="#00000066"
                                >
                                    mdi-account-outline
                                </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content
                                :class="active ? 'white--text' : ''"
                            >
                                <!-- list title -->
                                <v-list-item-title v-if="onSearch">
                                    <text-highlight :queries="[search]">
                                        {{ email.from_name }}
                                    </text-highlight>
                                </v-list-item-title>
                                <v-list-item-title
                                    v-else
                                    v-text="email.from_name"
                                />

                                <!-- list subtitle -->
                                <v-list-item-subtitle v-if="onSearch" :class="active ? 'white--text' : ''">
                                    <text-highlight :queries="[search]">
                                        {{ formatEmailSubject(email.subject) }}
                                    </text-highlight>
                                    <v-chip
                                        v-if="emailsChain.childs[email.from_email].unreadMessageCount != 0"
                                        class="ma-2"
                                        color="red"
                                        text-color="white"
                                    >
                                        {{ emailsChain.childs[email.from_email].unreadMessageCount + ' unread' }}
                                    </v-chip>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle v-else :class="active ? 'white--text' : ''">
                                    {{ email.subject.substr(0, 30) + (email.subject.length > 30 ? '...' : '') }}
                                    <v-chip
                                        v-if="emailsChain.childs[email.from_email].unreadMessageCount != 0"
                                        class="ma-2"
                                        color="red"
                                        text-color="white"
                                    >
                                        {{ emailsChain.childs[email.from_email].unreadMessageCount + ' unread' }}
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-row
                                    no-wrap
                                    no-gutters
                                    justify-end
                                    align-center
                                    class="pr-4"
                                >
                                    <!-- This will be added once 'importance levels' are provided by the api -->
                                    <!-- <v-icon small color="error lighten-1">mdi-alert-circle</v-icon> -->
                                    <v-icon
                                        v-if="email.priority && email.priority.code === 'urgent'"
                                        small
                                        color="error lighten-1"
                                    >
                                        mdi-clock-outline
                                    </v-icon>
                                </v-row>
                            </v-list-item-action>
                            <v-divider
                                vertical
                                light
                                class="ml-auto mr-n4"
                                :style="active ? 'border-width: 0 thin 0 0;' : 'border-width: 0 0 0 0;'"
                                color="#304FFE"
                            />
                        </template>
                    </v-list-item>
                    <v-divider light :key="email.id+'b'" />
                </template>
            </v-list-item-group>
            <slot />
        </v-list>
</template>

<script>
    export default {
        props: {
            // eslint-disable-next-line vue/require-default-prop
            emailsChain: Object,
            // eslint-disable-next-line vue/require-default-prop
            selectedEmail: Object,
            search: {
                required: false,
                default: '',
                type: String,
            },
            onSearch: Boolean,
        },
        data() {
            return {
                selected: [],
            };
        },
        methods: {
            formatEmailSubject(subject) {
                return subject.substr(0, 30) + (subject.length > 30 ? '...' : '');
            }
        }
    };
</script>

<style scoped>
.chosen-message {
    background-color: #181235;
}

/* .chosen-message .v-list-item__title,
.chosen-message .v-list-item__subtitle {
  color: #ffffff;
} */
</style>
